const escapeRegExp = (value: string): string => {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

if (typeof String.prototype.replaceAll !== 'function') {
  Object.defineProperty(String.prototype, 'replaceAll', {
    value: function polyfilledReplaceAll(
      this: string,
      searchValue: string | RegExp,
      replaceValue: string
    ) {
      const source = String(this);
      if (searchValue instanceof RegExp) {
        if (!searchValue.global) {
          throw new TypeError('String.prototype.replaceAll called with a non-global RegExp');
        }
        return source.replace(searchValue, replaceValue);
      }

      const search = String(searchValue);
      if (search === '') {
        return source.split('').join(replaceValue) + replaceValue;
      }

      return source.replace(new RegExp(escapeRegExp(search), 'g'), replaceValue);
    },
    writable: true,
    configurable: true,
  });
}

export {};
